import React, { Component } from 'react';
import { ToastManagerProp, withToastManager } from 'react-toast-notifications';

import attendanceStyles from 'components/Admin/AttendanceDetails.module.scss';
import Dialog from 'components/Dialog';
import sharedStyles from 'components/shared.module.scss';
import { Button, LoaderSpinner } from 'components/UtilElements';
import { apiErrorHandler } from 'core/errors';
import { getCancelToken } from 'redux/api';

import { getStudentAnalytics } from './StudentAnalytics';
import StudentAnalyticsTable from './StudentAnalyticsTable';

interface CourseAnalyticsDetailsProps extends ToastManagerProp {
  isOpen: boolean;
  course: CourseAnalyticsStats | null;
  onClose(): void;
}

interface CourseAnalyticsDetailsState {
  isLoading: boolean;
  students: StudentAggregateAnalytics[];
}

class CourseAnalyticsDetails extends Component<CourseAnalyticsDetailsProps, CourseAnalyticsDetailsState> {
  apiSources = getCancelToken();

  state: CourseAnalyticsDetailsState = {
    isLoading: true,
    students: [],
  };

  async getStudentAnalytics() {
    return getStudentAnalytics(this.apiSources.token);
  }

  async componentDidMount() {
    try {
      this.apiSources = getCancelToken();
      const students = await this.getStudentAnalytics();
      this.setState({ students, isLoading: false });
    } catch (err: any) {
      apiErrorHandler(this.props.toastManager, err, () => {
        this.setState({ isLoading: false });
      });
    }
  }

  componentWillUnmount() {
    this.apiSources.cancel();
  }

  render() {
    const { course, isOpen, onClose } = this.props;
    const { isLoading } = this.state;

    return (
      <Dialog
        isOpen={isOpen}
        onClose={onClose}
        title={
          <div className={attendanceStyles['class-attendance-details']}>
            <div className={attendanceStyles.number}>Student insights</div>
            <div className={attendanceStyles.title}>
              {course?.courseCode} - {course?.title}
            </div>
          </div>
        }
        footer={
          <Button variant='text' color='success' size='small' onClick={onClose} preventHoverStyles>
            DONE
          </Button>
        }
      >
        {isLoading ? (
          <div className={sharedStyles['loader-wrapper']}>
            <LoaderSpinner />
          </div>
        ) : (
          <StudentAnalyticsTable showEnrolledCourses={false} students={this.state.students} />
        )}
      </Dialog>
    );
  }
}

export default withToastManager(CourseAnalyticsDetails);
